import { withShowIf } from "../../../../components/with-show-if/with-show-If.component";
import { BriefListTable } from "../brief-list-table/brief-list-table.component";
import React from "react";
import { BriefListTableViewProps } from "./brief-list-table-view.props";

export const BriefListTableView = withShowIf((props: BriefListTableViewProps) => (
  <BriefListTable dataList={props.dataList} briefType={props.briefType} />
));
